export default {
    name: 'NumberTwoCircleFilled',
    dimensions: { width: 40, height: 40 },
    content: `
    <g clip-path="url(#clip0_12_1906)">
    <path d="M20 40.033C31.0457 40.033 40 31.0787 40 20.033C40 8.98726 31.0457 0.032959 20 0.032959C8.9543 0.032959 0 8.98726 0 20.033C0 31.0787 8.9543 40.033 20 40.033Z" fill="currentColor"/>
    <path d="M17.5 17.533C17.5 16.8699 17.7634 16.234 18.2322 15.7652C18.7011 15.2964 19.337 15.033 20 15.033H20.21C20.5967 15.0753 20.9658 15.2172 21.2813 15.4448C21.5968 15.6724 21.8479 15.9779 22.0101 16.3315C22.1723 16.6851 22.2401 17.0747 22.2067 17.4623C22.1734 17.8499 22.0402 18.2222 21.82 18.543L17.5 25.033H22.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1906">
    <rect width="40" height="40" fill="white" transform="translate(0 0.032959)"/>
    </clipPath>
    </defs>
    `
};
